module.exports = __webpack_public_path__ + "static/media/Path-v2.8958be71.png";